export const validationReviewsForm = (formData, setErrors) => {
    if (!formData.name && !formData.text) {
        setErrors({
            name: 'Name is required',
            text: 'Review is required',
        })
        return false
    }

    if (!formData.name.length) {
        setErrors({
            name: 'Name is required',
            question: false,
        })
        return false
    }
    if (!formData.text.length) {
        setErrors({
            name: false,
            text: 'Review is required',
        })
        return false
    }
    return true
}
